import { Component, OnInit } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import { SapRoles } from "src/_constants/roleType";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-test-cases",
  templateUrl: "./test-cases.component.html",
  styleUrls: ["./test-cases.component.scss"],
})
export class TestCasesComponent implements OnInit {
  testCasesList: string[] = [];
  testCasesObj = {};
  testCasesResult = [];
  AllTestCases = false;
  isDisabled = true;
  ProviderId = new FormControl([]);
  operatorId = new FormControl([]);
  userId;
  userToken;
  providers = [];
  providerList = [];
  operatorData = [];
  AllTestCasesSelected = [];
  requiredTestCases = [];
  sapRoles = SapRoles;
  wallet: string = "";
  dropdownSettings: any = {};
  operatorSettings: any = {};

  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(private appService: AppService, private router: Router) {}

  ngOnInit() {
    this.operatorSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_id",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    //this.getTestCases(this.ProviderId);
    this.getOperatorData();
  }

  // getOurProviders() {
  //   try {
  //     this.appService.getOurProviders().subscribe((res) => {
  //       if (res.status === "RS_OK") {
  //         this.providers = res.providers;
  //       } else {
  //         if (res.errorDescription === "Invalid Token!") {
  //           sessionStorage.clear();
  //           this.router.navigateByUrl("/login");
  //         }
  //       }
  //     });
  //   } catch (err) {}
  // }

  onSelectedProvider = (pid) => {
    this.ProviderId.setValue([pid]);
    if (pid === "Exchange" && this.providers.includes("BetFair")){
      this.ProviderId.setValue(["BetFair"]);
    }
    this.getTestCases(this.ProviderId.value[0],"");
  };

  setAll(checked) {
    this.AllTestCases = checked;
    if (checked) {
      this.AllTestCasesSelected = this.testCasesList;
      this.isValid();
    } else {
      this.AllTestCasesSelected = [];
      this.isValid();
    }
  }

  onCheckingTestCase(checked, item) {
    if (checked) {
      this.requiredTestCases.push(item);
      this.AllTestCasesSelected.push(item);
      this.isValid();
    } else {
      let index = this.requiredTestCases.indexOf(item);
      this.requiredTestCases.splice(index, 1);
      this.AllTestCasesSelected = this.AllTestCasesSelected.filter(testCase => testCase !== item);
      this.isValid();
    }
  }

  getOperatorData() {
    try {
      this.appService.getOperatorWallet().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
              fb = b.operator_id.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
          if (this.userRole.role === this.sapRoles.OperatorAdmin || this.userRole.role === this.sapRoles.OperatorUser) {
            this.onSelectedOperatorId(this.userRole.operatorId)
          }
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedOperatorId = (OperatorId) => {
    console.log(this.operatorId)
    this.operatorId.setValue([OperatorId]);
    const filteredOperators = this.operatorData.filter(oper => oper.operator_id === this.operatorId.value[0].operator_id);
    this.wallet = filteredOperators[0].wallet_type;
    if (this.wallet === "Transfer") {
      this.getTestCases("",this.wallet);
    } else {
      this.ProviderId.setValue([]);
      this.testCasesObj = {};
      this.testCasesList = [];
      this.getOurProviders(this.operatorId.value[0].operator_id);
    }
  };

  getOurProviders(oid) {
    try {
      this.appService.getOperatorProvidersStatus(oid).subscribe((res) => {
        if (res.status === "RS_OK") {
          if (res.operatorStatus) {
            this.providers = res.operatorStatus.filter(provider => provider.isEnabled === true).map(provider => provider.providerId);;
          }
          this.providerList = [];
          this.modifyProviders(this.providers)
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  modifyProviders(providers: any) {
    if (providers.includes("SportRadar")) {
      this.providerList = this.providerList.concat("SportsBook");
    }
    const containsOtherProvider = providers.some(provider => provider !== "SportRadar");
    if (containsOtherProvider) {
      this.providerList = this.providerList.concat("Exchange");
    }
  }

  getTestCasesResult() {
    this.router.navigate(["/reports/test-cases-results"], {
      queryParams: {
        operatorId: this.operatorId.value[0].operator_id,
        userId: this.userId,
        providerId: this.ProviderId.value[0],
        userToken: this.userToken,
        testCases: this.AllTestCases
          ? this.AllTestCasesSelected
          : this.requiredTestCases,
      },
    });
  }

  onChangingSessionOutcome(value, index) {
    if (index == "operatorId") {
      this.operatorId.setValue([value]);
    }
    if (index == "userId") {
      this.userId = value;
    }
    if (index == "userToken") {
      this.userToken = value;
    }
    this.isValid();
  }

  isValid() {
    if (
      this.operatorId.value.length &&
      this.userId.length &&
      this.userToken.length &&
      (this.AllTestCasesSelected.length >= 1 ||
        this.requiredTestCases.length >= 1)
    ) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  getTestCases(providerId, wallet) {
    try {
      this.appService.getTestCases(providerId, wallet).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.testCasesObj = res.testCases;
          this.testCasesList = Object.keys(res.testCases);
        } else {
          this.testCasesObj = {};
          this.testCasesList = [];
          console.log("Error");
        }
      });
    } catch (err) {}
  }
}
